import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSizeMLarge = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 31.195 41.593",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "M-L_Banner",
		transform: "translate(6609 21323)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_179",
			"data-name": "Group 179",
			transform: "translate(-6609 -21323)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_206",
				"data-name": "Path 206",
				d: "M30.729,1.733a1.637,1.637,0,0,1,1.733,1.733V38.127a1.637,1.637,0,0,1-1.733,1.733H6.466a1.637,1.637,0,0,1-1.733-1.733V3.466A1.637,1.637,0,0,1,6.466,1.733H30.729m0-1.733H6.466A3.476,3.476,0,0,0,3,3.466V38.127a3.476,3.476,0,0,0,3.466,3.466H30.729a3.476,3.476,0,0,0,3.466-3.466V3.466A3.476,3.476,0,0,0,30.729,0Z",
				transform: "translate(-3)"
			})
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_2710",
			"data-name": "Path 2710",
			d: "M4.347-7.82l3.481,9.83,3.463-9.83h3.667V5.733h-2.8v-3.7l.279-6.395L8.778,5.733H6.86L3.211-4.358l.279,6.386v3.7H.7V-7.82Z",
			transform: "translate(-6601.208 -21301.102)"
		})]
	})
});
export default SvgSizeMLarge;
